import { createStore } from 'vuex'
import quizStore from './quiz'

export default createStore({
  modules: {
    quiz: quizStore
  }
})
